<template>
  <div class="mt-5">
    <table class="table table-sm text-center interval-table">
      <thead class="thead-light">
        <tr>
          <th>{{'dro.list.interval' | trans}}</th>
          <th>{{'dro.list.time' | trans}}</th>
          <th>{{'dro.list.target_behaviour' | trans}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="interval in intervals" :key="interval.index">
          <td>{{interval.index}}{{'dro.list.interval_suffix' | trans}}</td>
          <td>{{interval.duration | minutes}}</td>
          <td>{{(interval.behaviourHappenedAt === null ? '-' : interval.behaviourHappenedAt) | minutes}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import {mapState} from 'vuex';

  export default {
    computed: {
      ...mapState('dro/session', [
        'intervals',
      ]),
    },
  };
</script>


// WEBPACK FOOTER //
// src/modules/dro/components/IntervalList.vue